import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

const screen = SCREEN.FINANCIAL_ANALYSIS

export const getNonLifeInsLiquidityThunk = createAsyncThunk(
  'financialAnalysis/NonLifeIns/getNonLifeInsLiquidity',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getLiquidity(data)
    if (response.success) {
      const getValues = () => mapAllVNDValue(response.data)
      dispatch(calculateDefaultUnit({ screen, getValues }))
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonLifeInsLiquidity = createAsyncThunk(
  'financialAnalysis/NonLifeIns/downloadNonLifeInsLiquidity',
  async (data) => {
    const response = await FinancialAnalysisService.downloadLiquidity(data)
    handleExport(response.data, response.filename)
  },
)
